import React, { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import "./navbar.css";
import logo from "../../assets/ACADMEY-12.png";
import MarqueeBanner from "../marquee_banner/MarqueeBanner";
import { useTour } from "../tour/TourContext";

export default function Header() {
  const { openVideo, openRequest } = useTour();

  // ====== Hamburger Toggle ===== //
  const [isActive, setActive] = useState(false);
  const [isScrolled, setScrolled] = useState(false);

  // Shrink the bar and tuck the announcement away once the visitor starts scrolling.
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const closeMenu = () => setActive(false);

  return (
    <header className={`navbar ${isScrolled ? "scrolled" : ""}`}>
      <MarqueeBanner />
      <div className="navbar-inner">
        <Link to="/" className="navbar-logo" onClick={closeMenu}>
          <img src={logo} alt="Learning In Motion Academy" />
        </Link>

        <button
          type="button"
          className={`hamburger ${isActive ? "active" : ""}`}
          onClick={() => setActive(!isActive)}
          aria-label="Menu"
          aria-expanded={isActive}
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>

        <nav className={`nav-menu ${isActive ? "active" : ""}`}>
          <ul>
            <li>
              <NavLink to="/" end className="nav-link" onClick={closeMenu}>Home</NavLink>
            </li>
            <li>
              <NavLink to="/curriculum" className="nav-link" onClick={closeMenu}>Curriculum</NavLink>
            </li>
            <li>
              <NavLink to="/about" className="nav-link" onClick={closeMenu}>About</NavLink>
            </li>
            <li>
              <NavLink to="/tuition" className="nav-link" onClick={closeMenu}>Tuition</NavLink>
            </li>
            <li>
              <NavLink to="/contact" className="nav-link" onClick={closeMenu}>Contact</NavLink>
            </li>
            <li className="nav-actions">
              <button
                type="button"
                className="nav-tour"
                onClick={() => {
                  closeMenu();
                  openVideo();
                }}
                aria-label="Watch a virtual tour of our school"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="26" height="26" fill="currentColor" aria-hidden="true">
                  <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm-2 14.5v-9l7 4.5-7 4.5Z" />
                </svg>
                <span>Virtual Tour</span>
              </button>
              <button
                type="button"
                className="btn btn-pink nav-cta"
                onClick={() => {
                  closeMenu();
                  openRequest();
                }}
              >
                Schedule a Tour
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}
